import React, { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap"
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { config } from '../../CommonUtils/CommonURLS'
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from "react-icons/fa";
import { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations'
import Swal from 'sweetalert2'
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
import * as Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables'
import { useSelector } from 'react-redux'
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice'
export default function FFCAINSTRUCTIONALAREADETAILS21() {
    const LandType = useSelector((state) => state?.commonMastersReducer?.CollegeType);

    const hasFetchedData = useRef(false);
    const ffcaInstructioalvalidations = Yup.object().shape({
        instructionalArea: Yup.array().of(
            Yup.object().shape({
                ffcaStatus: Yup.string().required(ERROR_MSG).nullable(),
                ffcaArea: Yup.string().required(ERROR_MSG).nullable(),
            })
        ),
    });
    const FFcaInstructionFormik = useFormik({
        initialValues: {
            instructionalArea: [{
                ffcaStatus: "",
                ffcaArea: "",
                slno: "",
                ffcaInstrDef: "",
            }]

        },
        validationSchema: ffcaInstructioalvalidations,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}updateFfcaInstructionalAreadetails`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetBuildingReport();
                        } else {
                            failureAlert(res?.data?.sdesc);

                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })
    const [instructional, setinstructional] = useState([])
    function GetBuildingReport() {
        let url = config?.url?.API_URL + "getFfcaInstructionaldata";
        CommonAxiosGet(url).then((res) => {
            if (res?.data !== undefined || res?.data !== null || res?.data !== '') {
                setinstructional(res?.data);
                res?.data?.ffcaInstructionalData?.forEach((buildingdata, i) => {
                    FFcaInstructionFormik?.setFieldValue(`instructionalArea[${i}]slno`, buildingdata?.slno);
                    FFcaInstructionFormik?.setFieldValue(`instructionalArea[${i}].ffcaStatus`, buildingdata?.ffca_status);
                    FFcaInstructionFormik?.setFieldValue(`instructionalArea[${i}].ffcaInstrDef`, buildingdata?.ffca_instr_def);
                    FFcaInstructionFormik?.setFieldValue(`instructionalArea[${i}].ffcaArea`, buildingdata?.ffca_area);
                })
            }
            else {
                setinstructional([]);
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetBuildingReport();
            GetCollegeType();
            hasFetchedData.current = true
        }
    }, [])
    const calculateDifference = (ffcaArea, totalCarpetArea) => {
        if (!ffcaArea) {
            return '';
        }
        const utilizationValue = parseFloat(ffcaArea);
        if (utilizationValue <= totalCarpetArea) {
            return 0;
        }
        return utilizationValue - totalCarpetArea;
    };
    return (<>

        <CommonFormHeading heading="Instructional Area Deficiency Details" />
        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
            <FormikProvider value={FFcaInstructionFormik}>
                <Form onChange={FFcaInstructionFormik.handleChange} onSubmit={FFcaInstructionFormik.handleSubmit} className="affl-form" >
                    <bie.Row className="px-2 pt-3 mb-3">
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th className='cen'> Sl no</th>
                                        <th>Particulars </th>
                                        <th>Building/Block Name</th>
                                        <th>Level/Floor No.	</th>
                                        <th> Room no.</th>
                                        <th>Total Carpet Area Provided({LandType})	</th>
                                        <th>Image</th>
                                        <th>Is the Picture of the Room submitted by college and the room really the same Yes/No</th>
                                        <th>Area that shall be provided as per the Norms of the University({LandType})	</th>
                                        <th>Deficiency ({LandType})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {instructional?.ffcaInstructionalData?.map((empDetail, index) => {

                                        const totalCarpetArea = parseFloat(empDetail?.total_area);
                                        const utilizationValue = FFcaInstructionFormik?.values?.instructionalArea[index]?.ffcaArea || '';
                                        const deficiencyValue = calculateDifference(utilizationValue, totalCarpetArea); // Get deficiency value

                                        return (
                                            <tr key={empDetail.slNo}>
                                                <td className='cen'>{index + 1}</td>
                                                <td className='text-left'>{empDetail?.particular_name}</td>

                                                <td className='text-left'>{empDetail?.build_block_name}</td>

                                                <td>{empDetail?.floor_no_build_block}</td>
                                                <td>{empDetail?.no_of_rooms}</td>
                                                <td>{empDetail?.total_area}</td>
                                                <td>{empDetail?.building_img ? (
                                                    <button type="button" className="btn btn-primary" onClick={() => { viewImage(empDetail?.building_img) }}><FaEye size={20} className='cen' /></button>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                                </td>
                                                <td>
                                                    <Field type="hidden" name={`instructionalArea[${index}].slno`} />
                                                    <div>
                                                        <Field as="select" name={`instructionalArea[${index}].ffcaStatus`} className="form-control">
                                                            <option value=''>--Select--</option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option></Field>

                                                        <ErrorMessage name={`instructionalArea[${index}].ffcaStatus`} component="div" className="text-error" />

                                                    </div>
                                                </td>
                                                <td>
                                                    <Field type="text" name={`instructionalArea[${index}].ffcaArea`} className="form-control" onKeyPress={(e) => { AllowFloats(e) }}
                                                        onPaste={(e) => handlePaste(e)}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            FFcaInstructionFormik?.setFieldValue(`instructionalArea[${index}].ffcaArea`, newValue);
                                                            const updatedDeficiency = calculateDifference(newValue, totalCarpetArea);
                                                            FFcaInstructionFormik?.setFieldValue(`instructionalArea[${index}].ffcaInstrDef`, updatedDeficiency);
                                                        }}
                                                    />
                                                    <ErrorMessage name={`instructionalArea[${index}].ffcaArea`} component="div" className="text-error" />
                                                </td>
                                                <td>
                                                    <Field
                                                        type="text"
                                                        name={`instructionalArea[${index}].ffcaInstrDef`}
                                                        className="form-control"
                                                        value={deficiencyValue}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {instructional ? (<>
                            <div className="button-cend pt-1">
                                <button type='submit' className='btn btn-success btn-sm float-end mb-2'>Submit</button>
                            </div>
                        </>) : (<></>)}
                        <div className="inner-herbpage-service-title-sub">
                            <h1 className="mb-0">Instructional Area Summary Report</h1></div>
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>Sl.No</th>
                                        <th>Particulars</th>
                                        <th>Total number Provided by college	</th>
                                        <th> Total Deficiency in Sq Feet</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {instructional?.particularsData?.map((room, index) => (
                                        <tr key={index + 1}>
                                            <td className='cen'> {index + 1}</td>
                                            <td className='text-left'> {room.particular_name}</td>
                                            <td className='cen'>{room.total_particular}</td>
                                            <td className='cen'>{room?.ffca_instr_def}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {instructional?.areaReportData?.length > 0 ? (<>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">ClassRoom Utilization Report</h1></div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Sl.No</th>
                                            <th>Total number Of ClassRooms</th>
                                            <th>Utilized Class Rooms	</th>
                                            <th> Non-Utilized ClassRooms	</th>
                                            <th>Utilized area</th>
                                            <th>Non Utilized Area	</th>
                                            <th>Area that will be released because of Withdrawing the courses</th>
                                            <th>Area that will be required for additional sections</th>
                                            <th>Area that will be required for additional courses</th>
                                        </tr>
                                    </thead>
                                    {instructional?.areaReportData?.map((room, index) => (
                                        <tbody>
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td>{room?.no_cls_rms}</td>
                                                <td>{room?.utilization}</td>
                                                <td>{room?.non_utilization}</td>
                                                <td>{room?.utilization_area}</td>
                                                <td>{room?.non_utilization_area}</td>
                                                <td>{room?.tot_class_area_withdrawl}</td>
                                                <td>{room?.tot_class_area_aditional}</td>
                                                <td>{room?.tot_class_area_aditional_new_course}</td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                        </>) : (<></>)}
                    </bie.Row>
                </Form>
            </FormikProvider>
        </bie.Container>
    </>)
}
